import { AxiosResponse } from "axios";
import { IPatrocinador } from "interfaces/patrocinador";
import api from "./api";

function ensureSuccess<T>(response: AxiosResponse<T>): T {
  if (response.status >= 400) {
    const data = response.data as any;
    throw new Error(data?.message || "Falha na comunicacao com o servidor");
  }

  return response.data;
}

function ensureArray<T>(data: T[] | null | undefined): T[] {
  return Array.isArray(data) ? data : [];
}

function normalizeError(error: unknown) {
  return new Error(
    error instanceof Error ? error.message : "Falha na comunicacao com o servidor"
  );
}

export async function getAllPatrocinadores(): Promise<IPatrocinador[]> {
  try {
    const response = await api.get<IPatrocinador[]>("/patrocinadores/admin");
    return ensureArray(ensureSuccess(response));
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function getPatrocinadoresPorEvento(
  eventoId: number
): Promise<{ patrocinador: IPatrocinador; ordem: number }[]> {
  try {
    const response = await api.get<{ patrocinador: IPatrocinador; ordem: number }[]>(
      `/patrocinadores?eventoId=${eventoId}`
    );
    return ensureArray(ensureSuccess(response));
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function createPatrocinador(formData: FormData) {
  try {
    const response = await api.post<IPatrocinador>("/patrocinadores", formData);
    ensureSuccess(response);
    return response;
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function editPatrocinador(id: number, formData: FormData) {
  try {
    const response = await api.put<IPatrocinador>(`/patrocinadores/${id}`, formData);
    ensureSuccess(response);
    return response;
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function deletePatrocinador(id: number) {
  try {
    const response = await api.delete(`/patrocinadores/${id}`);
    ensureSuccess(response);
    return response;
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function vincularPatrocinadorEvento(
  patrocinadorId: number,
  eventoId: number,
  ordem: number = 0
) {
  try {
    const response = await api.post(`/patrocinadores/${patrocinadorId}/vincular`, {
      eventoId,
      ordem,
    });
    ensureSuccess(response);
    return response;
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function desvincularPatrocinadorEvento(
  patrocinadorId: number,
  eventoId: number
) {
  try {
    const response = await api.delete(
      `/patrocinadores/${patrocinadorId}/vincular/${eventoId}`
    );
    ensureSuccess(response);
    return response;
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function reordenarPatrocinadores(
  items: { id: number; ordem: number }[]
) {
  try {
    const response = await api.patch("/patrocinadores/ordem", items);
    ensureSuccess(response);
    return response;
  } catch (error) {
    throw normalizeError(error);
  }
}
